import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';
import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';

export const GetFotaLogs = async (page, search) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.GET_FOTA_LOGS}?page=${page}&limit=10&search=${search}`
  );
  return response;
};

export const SaveFotaVersion = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.SAVE_FOTA_VERSION,
    data
  );
  return response;
};

export const UpdateFotaVersionById = async (id, data) => {
  const response = await SmartLockApiCallerInstance.post(
    `${SMART_LOCK_API_ENDPOINTS.SAVE_FOTA_VERSION}/${id}`,
    data
  );
  return response;
};

export const GetVersionList = async () => {
  const response = await SmartLockApiCallerInstance.get(SMART_LOCK_API_ENDPOINTS.SAVE_FOTA_VERSION);
  return response;
};
export const GetVersionById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.SAVE_FOTA_VERSION}/${id}`
  );
  return response;
};
export const DeleteVersion = async (id) => {
  const response = await SmartLockApiCallerInstance.delete(
    `${SMART_LOCK_API_ENDPOINTS.SAVE_FOTA_VERSION}/${id}`
  );
  return response;
};
export const ApplyFotaVersion = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.APPLY_FOTA_VERSION,
    data
  );
  return response;
};
export const GetFotaLogsByDeviceId = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.GET_FOTA_LOGS}/${id}`
  );
  return response;
};
